
import { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { useCookies } from 'react-cookie';
import SplashScreen from 'components/organisms/SplashScreen';
import Page from 'components/templates/Page';
import ModalManager from 'components/services/ModalManager';
import ToolContext from 'components/services/ToolContext';
import ReducersIndex from 'reduxModules/ducks';
import { camelCase } from 'lodash';

import Load from 'components/services/Load';
import isEmpty from 'lodash/isEmpty';
import RedirectScreen from 'components/organisms/RedirectScreen';

// NOTE: tHE COMMENTED OUT STUFF DOES ADD A SLICE TO THE STORE BUT NOT INSIDE EXISTING SLICE BUT AS ANOTHER SLICE ALTOGETHER
// import ceiling, {ceilingReducers} from 'reduxModules/ducks/ceiling';
// import { useStore } from 'react-redux';
// import { createAction } from '@reduxjs/toolkit';

const Main = ({ tool, setHide }) => {
  const redirect = tool.constants.tool.goto;
  const inWorkplace = tool.constants.tool?.inWorkplace || false;
  const { search } = useLocation();
  const backDoor = search.includes('clmteamaccess');
  const saveLink =  search.includes('savekey');

  // Redirect if tool in in workplace, I have a link, there's no backdoor access and no saved document key 
  if (inWorkplace && redirect && !backDoor && !saveLink) { // window.location.replace(redirect); //    href = redirect;
    console.log("Redirecting: ", redirect);
    
    // Clear all storage
    sessionStorage.clear();
    localStorage.clear();
    
    // Force hard reload and redirect
    window.location.replace(redirect + '?_=' + Date.now());
  };

  const [splashOpen, setSplashOpen] = useState(true);
  const [projectLoaded, setProjectLoaded] = useState(false);
  const [firstTimeUser, setFirstTimeUser] = useState(true);
  const isFirstTimeUser = useSelector(state => state.ui.isFirstTimeUser);
  // const { search } = useLocation();
  const target = tool.modals['launch'].target;
  const cookieName = tool.constants.tool.cookie;

  const [cookies, setCookie] = useCookies([cookieName]);

  const dispatch = useDispatch();

  

  
  const toolName = camelCase(tool.constants.tool.fullName);
  const [name, setName] = useState(toolName);

  useEffect(() => {
    dispatch(ReducersIndex.uiReducers.setTool(toolName));
    setName(toolName)
    // eslint-disable-next-line
  }, [toolName]);

  // Deal with the cookies thing
  useEffect(() => {
    if (!isEmpty(cookies) && cookieName in cookies) {
      dispatch(ReducersIndex.uiReducers.setIsFirstTimeUser(false));
      setFirstTimeUser(false);
    } 
  }, [cookies, cookieName, dispatch])

  useEffect(() => {
    if (!isFirstTimeUser) {
      const date = new Date();
      const today = date.getDate();
      date.setMonth(date.getMonth() + 6);
      if (date.getDate() !== today) {
        date.setDate(0)
      };
      setCookie(cookieName, true, {expires : date})
    }
  }, [isFirstTimeUser, cookieName, setCookie] )

  const closeSplash = (e) => {
    setSplashOpen(false);
    setProjectLoaded(true);

    if (firstTimeUser) {
      const tutorialSteps = tool.tutorialSteps;
      dispatch(ReducersIndex.uiReducers.setTutorialConfig(tutorialSteps));
      dispatch(ReducersIndex.uiReducers.openModal('tutorial'));
    } else {
      dispatch(ReducersIndex.uiReducers.openModal(target));
    };
  };

  const headerRef = useRef(null);
  const [top, setTop] = useState(0);
  useEffect(() => {
    if (headerRef.current) {
      const bbox = headerRef.current.getBoundingClientRect()
      setTop(bbox.bottom);
    }
  }, [splashOpen, projectLoaded]);

  // todo
  // hide the headee/footer from main


  useEffect(() => {
    if (inWorkplace && saveLink) {
      setHide(!backDoor);
    };
  }, [inWorkplace, saveLink, backDoor, setHide]);

  // console.log("ready: ", {
  //   search,
  //   alt: JSON.stringify(search),
  //   shouldBe: JSON.stringify({savekey: 'crd-12345', ver: '2'}),
  //   inWorkplace,
  //   projectLoaded,
  //   splashOpen,
  //   backDoor,
  //   saveLink,
  // });

  return (
    <div className='flex-grow-1 container-fluid p-2'>
      {/* Show stop screen when tryoong to retrieve project from legacy tool */}
      {(inWorkplace && !backDoor && saveLink) && 
        <ToolContext.Provider value={tool}>
          <RedirectScreen params={search} />
        </ToolContext.Provider>
      }




      {/* Non workplace tools, or workplace access with backdoor */}
      {(!inWorkplace || (inWorkplace && backDoor)) && <ToolContext.Provider value={tool}>
        {name && <Load params={search} setProjectLoaded={setProjectLoaded} setSplashOpen={setSplashOpen} target={target} setFirstTimeUser={setFirstTimeUser}/>}
        {splashOpen && !projectLoaded && <SplashScreen closeSplash={closeSplash} />}
        {(!splashOpen && projectLoaded) && <Page ref={headerRef} showChild={!firstTimeUser}/>}
        <ModalManager top={top}/>
      </ToolContext.Provider>}
    </div>
  )
};

export default Main;